// extracted by mini-css-extract-plugin
module.exports = {"main_container":"styles_main_container__DsI1X","content_container":"styles_content_container__yTMh1"};